import moment from 'moment';

export default function statementBookingSeats({
  bookingData,
  departureClasses,
  returnClasses,
  bookingInfoForm,
  options,
}) {
  const statementRides = [];

  const seatClasses = departureClasses
    .filter((rideClass) => !rideClass?.seatGroupProperty?.id)
    .map((rideClass) => ({
      seatClassId: +rideClass.id,
      numberOfSeats: +rideClass.amount,
    }));

  const seatGroupProperties = departureClasses
    .filter((rideClass) => rideClass?.seatGroupProperty?.id)
    .map((rideClass) => ({
      seatClassId: +rideClass.id,
      numberOfSeats: +rideClass.amount,
      seatGroupPropertyId: +rideClass.seatGroupProperty.id,
    }));

  statementRides.push({
    rideId: bookingData?.departure.id,
    tariffId: null,
    startStationId: bookingData?.departure.startStation.id,
    endStationId: bookingData?.departure.endStation.id,
    endDate: moment(bookingData?.endDate).format('YYYY-MM-DD'),
    startDate: moment(bookingData?.startDate).format('YYYY-MM-DD'),
    seatClasses,
    seatGroupProperties,
  });

  if (bookingData?.return?.id) {
    const returnSeatClasses = returnClasses
      .filter((rideClass) => !rideClass?.seatGroupProperty?.id)
      .map((rideClass) => ({
        seatClassId: +rideClass.id,
        numberOfSeats: +rideClass.amount,
      }));

    const returnSeatGroupProperties = returnClasses
      .filter((rideClass) => rideClass?.seatGroupProperty?.id)
      .map((rideClass) => ({
        seatClassId: +rideClass.id,
        numberOfSeats: +rideClass.amount,
        seatGroupPropertyId: +rideClass.seatGroupProperty.id,
      }));
    statementRides.push({
      rideId: bookingData?.return?.id,
      tarrifId: null,
      startStationId: bookingData?.return?.startStation?.id,
      endStationId: bookingData?.return?.endStation?.id,
      endDate: moment(bookingData?.endDate).format('YYYY-MM-DD'),
      startDate: moment(bookingData?.startDate).format('YYYY-MM-DD'),
      seatClasses: returnSeatClasses,
      seatGroupProperties: returnSeatGroupProperties,
    });
  }
  const bookingValues = bookingInfoForm.getFieldsValue();
  if (bookingValues && options?.countries) {
    bookingValues.contactPerson.country_phone_code = options.phoneCodes
      .find((code) => code.value === bookingValues.contactPerson.country_phone_code).label;
  }
  return ({
    ...(bookingValues && {
      paymentTypeId: bookingValues.paymentTypeId,
      contactFirstName: bookingValues?.contactPerson?.first_name,
      contactLastName: bookingValues?.contactPerson?.last_name,
      contactCode: bookingValues?.booker?.id_number,
      groupLeaderFirstName: bookingValues?.groupSupervisor?.first_name,
      groupLeaderLastName: bookingValues?.groupSupervisor?.last_name,
      groupLeaderCode: bookingValues?.groupSupervisor?.id_number,
      address: bookingValues?.booker?.address,
      includingVat: Boolean(bookingValues?.includingVat),
      ...(!bookingValues?.includingVat && {
        vatCode: bookingValues.vatCode,
        vatFile: bookingValues.vatFile.uid,
      }),
    }),
    statementRides,
  });
}
